// components/styles.ts
import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: #003b71;
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  border-bottom: 1px solid #fff;
  background: #003b71;
  height: 75px;
  img {
    margin: 0 auto;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const Tab = styled.div<{ active?: boolean }>`
  padding: 5px 15px;
  background: ${props => (props.active ? '#d32f2f' : '#fff')};
  color: ${props => (props.active ? '#fff' : '#003087')};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
`;

export const ModalContent = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const Sidebar = styled.div`
  width: 30px;
  background: #ccc;
  border-right: 1px solid #fff;
`;

export const MainContent = styled.div`
  flex: 1;
  padding: 20px;
  background: #003b71;
  display: flex;
  justify-content: center;
  color: white;
  font-size: 12px;
  overflow-y: auto;
`;

export const ModalFooter = styled.div`
  color: white;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 20px;
  border-top: 1px solid #fff;
  background: #003b71;
`;

export const AcceptButton = styled.button`
  background: #28a745;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
`;

export const DeclineButton = styled.button`
  background: #dc3545;
  border: none;
  padding: 0px 20px;
  border-radius: 4px;
  cursor: pointer;
`;
